export let insetObject = {
	orderId: "",
	customerName: "",
	orderStatus: "",
	orderSource: "",
	createdDate: ""
}

export let tableHeader = [
	// {
	// 	text: "Id",
	// 	value: "customerGuid",
	// 	align: "left"
	// },
	{
		text: "Názov",
		value: "name",
		align: "left"
	},
	{
		text: "Ičo",
		value: "ico",
		align: "left"
	},
	{
		text: "Kontaktný e-mail",
		value: "contactEmail",
		align: "left"
	},
	{
		text: "Telefón",
		value: "phoneNumber",
		align: "left"
	},
	{
		text: "Posledné prihlásenie",
		value: "lastLogin",
		align: "left"
	},
	{
		text: "Vytvorený",
		value: "created",
		align: "left"
	},
	{
		text: "",
		value: "action",
		sortable: false
	}
]